/* ==========================================================================
   HOME PASSION - GORSEL GORUNURLUK GUVENCESI

   ==========================================================================
   COZULEN ASIL SORUN
   ==========================================================================
   Hero gorseli tam yuklenmis (naturalWidth 2160), .hp-in sinifi eklenmis,
   CSS'te ona uyan UC AYRI opacity:1 kurali var - ama hesaplanan opaklik 0.

   Sebep: gorselin uzerinde DONMUS bir CSS gecisi vardi.
     CSSTransition | sure 700ms | currentTime 0ms | durum running
     kareler 0 -> opacity 0, 1 -> opacity 1 | fill: backwards

   "fill: backwards" gecisin BASLANGIC degerini tutar ve calisan bir gecis
   her zaman CSS kurallarini yener. Gecis 0. milisaniyede takilirsa gorsel
   sonsuza kadar gorunmez kalir.

   Ne zaman olur: tarayici sayfayi ARKA PLANDA olusturdugunda gecisler
   ilerlemez (Ctrl+tik ile yeni sekme, geri tusu/bfcache, prerender).
   Sekme one geldiginde gecis kaldigi yerden DEVAM ETMEZ.

   ==========================================================================
   ILK DENEMEDE YAPTIGIM HATA - DUZELTILDI
   ==========================================================================
   Ilk surumde "son care" olarak 2,5 saniye sonra BUTUN gorselleri zorla
   gorunur yapiyordum. Olcum: 103 gorselin 100'u o anda hala yukleniyordu
   ve hepsi zorla gorunur yapilinca yuklenene kadar ALT METIN goruluyordu.
   Yani ortada olmayan bir sorunu "cozerken" gercek bir sorun yarattim.

   YENI KURAL: bu dosya asla yuklenmemis bir gorseli gorunur yapmaz.
   Sadece "yuklenmis AMA opakligi 0 kalmis" - yani kanitlanabilir sekilde
   takilmis - gorselleri kurtarir. Henuz yuklenenler zaten 'load' olayinda
   normal yoluyla acilir.
   ========================================================================== */
(function(){
  'use strict';
  if(window.__hpImgFix) return;
  window.__hpImgFix = 1;

  var MAX = 12000;          /* bu sureden sonra taramayi birak */
  var basla = Date.now();

  function yuklendi(img){
    return img.complete && img.naturalWidth > 0;
  }

  function kartAlternatifi(img){
    return img && img.classList.contains('alt') && img.closest('.hp-pc-img');
  }

  /* Yumusak: sadece sinifi ekle, fade-in CSS'e kalsin */
  function soft(img){
    if(!img || kartAlternatifi(img) || img.classList.contains('hp-in')) return;
    img.classList.add('hp-in');
  }

  /* Sert: takili gecisi iptal et. Gecisi 'none' yapmak calisan gecisi
     IPTAL eder; ondan sonra satir ici opaklik gecerli olur.
     Bir kare sonra gecis geri verilir ki sonraki animasyonlar bozulmasin. */
  function hard(img){
    img.classList.add('hp-in');
    var eski = img.style.transition;
    img.style.transition = 'none';
    img.style.opacity = '1';
    if(window.requestAnimationFrame){
      requestAnimationFrame(function(){ img.style.transition = eski || ''; });
    }
  }

  /* SADECE yuklenmis ama gorunmez kalmis olanlari kurtar.
     Yuklenmemis gorsele ASLA dokunma - alt metin gosterir. */
  function kurtar(){
    var list = document.querySelectorAll('.hp img');
    var takilan = 0;
    for(var i = 0; i < list.length; i++){
      var im = list[i];
      if(!yuklendi(im)) continue;                 /* <-- kritik kosul */
      if(kartAlternatifi(im)) continue;
      var op = 1;
      try{ op = parseFloat(getComputedStyle(im).opacity); }catch(e){}
      if(op < 0.99){ hard(im); takilan++; }
    }
    return takilan;
  }

  /* 1) Onbellek yarisi: gorsel yuklenir yuklenmez sinifi ekle.
        Onbellekten anlik gelen gorselde 'load' olayi dinleyici baglanmadan
        once atesleyebilir; capture asamasi bunu yakalar. */
  document.addEventListener('load', function(e){
    var t = e.target;
    if(t && t.tagName === 'IMG' && t.closest && t.closest('.hp')) soft(t);
  }, true);

  /* 2) Sekme one geldiginde donmus gecisleri bitir - ASIL DUZELTME */
  document.addEventListener('visibilitychange', function(){
    if(!document.hidden) kurtar();
  });

  /* 3) Geri / ileri tusu (bfcache geri yukleme) */
  window.addEventListener('pageshow', function(){ kurtar(); });

  /* 4) Normal akista kontrol noktalari */
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', kurtar);
  } else {
    kurtar();
  }
  window.addEventListener('load', kurtar);

  /* 5) Ilk 12 saniye boyunca seyrek tarama.
        Tembel yuklenen gorseller kaydirmayla geldikce takilan varsa yakalanir.
        Yuklenmemis gorsele dokunulmadigi icin alt metin riski yok. */
  var t = setInterval(function(){
    kurtar();
    if(Date.now() - basla > MAX) clearInterval(t);
  }, 1200);
})();
